
import { Component, Vue, Prop } from 'vue-property-decorator'
import { delObjEmptyKey, jsonToObjArr } from '@/utils'
@Component({
  name: 'orderDetail',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) info!: any

  private upstream_notify: any[] = []
  private upstream_request: any[] = []
  private upstream_response: any[] = []
  private notify_request: any[] = []
  private notify_response: any[] = []
  private subTabName: string = 'Upstream'
  private callBackInfo: any = {}

  private isPrint: boolean = false
  private clickPrint() {
    this.isPrint = true
    setTimeout(() => {
      this.isPrint = false
    }, 100)
  }

  private async init() {
    this.upstream_notify = jsonToObjArr(this.info.upstream_notify)
    this.upstream_request = jsonToObjArr(this.info.upstream_request)
    this.upstream_response = jsonToObjArr(this.info.upstream_response)
    this.notify_request = jsonToObjArr(this.info.notify_request)
    this.notify_response = jsonToObjArr(this.info.notify_response)
    if (
      this.info.upstream_notify &&
      this.info.upstream_notify !== 'undefined'
    ) {
      this.callBackInfo = JSON.parse(this.info.upstream_notify.transfer_info)
    }
  }

  mounted() {
    this.init()
  }
}
